import { FactoryProvider, InjectionToken } from '@angular/core';

export const WINDOW = new InjectionToken<Window>('window');

export const windowProvider: FactoryProvider = {
  provide: WINDOW,
  useFactory: () => window,
};
